/**
 * created by tian ruo jun
 * 2022/04/15
 * 稿件编辑器
 * 主要用于打开1.1版本稿件
 * 1.1版本稿件：新闻投稿写的稿件为1.0版本，投递至素材中心时生成的副本即为1.1
 * 新闻投稿和素材中心打开1.1版本稿件时都可以用这个编辑器打开
 * 区别于StoryEditor编辑器：右侧只有投递媒体列表，不可以选择投递目标
 */
import React, {Component} from 'react';
import StoryEditor from "../storyEditor/StoryEditor";
import {Button, Input, message,Modal,Select} from "antd";
import {base64Encode, uuid} from "../../../utils";
import {removeContentSecurity} from "../floatTool/securityCheck";
import {systemBaseEvent} from "../../../base/baseEvent";
import EditorPublishInformation from "../components/EditorPublishInformation";
import {publishInformationConfig} from "./publish/publishInformation-config";
import {getInfoFromLocalStorage} from "../../../actions";
import RenderPicker from "../../materialCenter/manuscriptsSubmitted/component/renderPicker";
import DiscardReason from '../components/discardReason/discardReason';

const {TextArea} = Input;
const {Option} = Select;
export default class MaterialCenterStoryEditor extends StoryEditor {
    constructor(props) {
        super(props);
        this.state = {
            discardReasonList: [
                { key: 1, value: 1, label: '文字问题' },
                { key: 2, value: 2, label: '格式问题' },
                { key: 3, value: 3, label: '图片问题' },
                { key: 4, value: 4, label: '链接问题' },
            ]
            // discardReason:undefined,
        }
    }

    pojoName = 'likewebsite';
    getPojoName = (story) => {
        let pojoName = this.pojoName;
        try {
            let pojonameList = this.sysConfigGetValueByKey("material.center.pojoname", "");
            if(pojonameList) {
                pojonameList = JSON.parse(pojonameList);
                let category = story[pojonameList.key];
                let pojo = pojonameList["value"][category];
                if(pojo) {
                    pojoName = pojo;
                }
            }
        } catch (e) {
            console.log(e.toString())
        }
        return pojoName
    };
    /**设置流程配置*/
    initActivitiConfig(story) {
        let id = (this.props.id && this.props.id.length > 1 && this.props.id != 'null' && this.props.id != 'undefined') ? this.props.id : '';
        let that = this;
        let userAccount = (window.currentUser && window.currentUser.account) ? window.currentUser.account : "";
        // 判断操作权限start
        // 1.1版本稿件会强制通过审核流推进到对应媒体编辑的待办中，此时该稿件已经存在审核流。
        // 所以这里不需要重启审核流，当1.1版本稿件不重启审核流时本身是没有操作按钮的，所以这里不需要判断操作权限
        let showBtnFlag = true;
        // 判断操作权限end
        let pojoName = this.getPojoName(story);
        let activitiConf = {type: "activitiTreeRoot-xlc-sczxsglc"};
        let againFlag = false;
        // if(story && story.statusName.startWith("提交至")) {
        //     againFlag = true;
        // }

        this.state.activityOption = {
            ...this.state.activityOption,
            id,//流程id
            activitiConf,//流程conf
            pojoName,//数据表name
            userAccount,//当前用户account
            showBtnFlag,//是否显示流程按钮
            againFlag,//重置流程的判断条件
            showAfterFuns: {
                /**
                 * 是否显示撤回按钮
                 */
                fromContribute: (item, call) => {
                    if (story && story.category==="interview" || story && story.category === "manuscripts") {
                        call({code: 0, log: "不显示撤回按钮！"});
                        return
                    }
                    call({code: 1});
                },
                /**
                 * 是否显示撤回按钮
                 */
                callBackBtnShow: (item, call) => {
                    // 点击素材中心稿件标题进入的稿件
                    let activitiConfName = that.sysConfigGetValueByKey("editor.activiti.goBack.states", "已返回写稿人,返回写稿人");
                    // 稿件状态为返回写稿人
                    if (story && story.statusName && activitiConfName.includes(story.statusName)) {
                        call({code: 0, log: "不显示撤回按钮！"});
                        return
                    }
                    call({code: 1});
                },
            },//流程按钮加载前置js
            getTextRequisite: false,//备注是否必填
            otherJs: {
                callActRevert: (activiti, buttonConf, call) => {
                    activiti.terminate.call(activiti, (res) => {
                        if (res) {
                            activiti.options.statusNameTemp = "草稿";
                            activiti.endFunction(activiti, function (res) {
                                if (res.status) {
                                    activiti.successMsg("流程已撤回，稿件变为草稿状态", function () {
                                        activiti.submitOK.call(activiti);
                                    });
                                } else {
                                    window.loading.hide();
                                }
                            })
                        } else {
                            window.loading.hide();
                        }
                    });
                },
                setSourceUser: (activiti, buttonConf, call) => {
                    let myId = (window.currentUser && window.currentUser.account) ? window.currentUser.id : "";
                    that.findOldUuid({
                        id, call: (res) => {
                            if (res && res.id) {
                                if (myId === res.submitter) {
                                    //使用throw强制抛出异常信息
                                    message.warning("当前稿件写稿人与当前操作人是同一人，无需返回");
                                    window.loading.hide();
                                    // call({code: -1, log: "当前稿件写稿人与当前操作人是同一人，无需返回"});
                                    return false;
                                }
                                activiti.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = [{
                                    id: res.submitter,
                                    name: res.submitterName,
                                    deptId: res.deptId,
                                }];
                                call({code: 1, log: "查询到返回者为：" + res.creator});
                            } else {
                                window.loading.hide();
                                message.error("未查到原始稿件，请刷新后重试");
                                call({code: -1, log: "未查到原始稿件，请刷新后重试"});
                            }
                        }
                    });
                },
                /**
                 * 修改完成后直接提交给返回的人 不经过中间审核
                 * @param activiti
                 * @param buttonConf
                 * @param call
                 */
                callAgent: function (activiti, buttonConf, call) {
                    let uuid = activiti.options.uuid;
                    that.request({
                        url: "/cm-sites-sys/process/getProcessHistory",
                        method: "post",
                        body: {bizKey: uuid},
                        callBack: (data) => {
                            var historyList = data;
                            if (historyList && historyList.length > 1 && historyList[0].candidateInfo && historyList[0].candidateInfo.length) {
                                var callBackHistory = historyList[0];
                                activiti.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = [{
                                    id: callBackHistory.operatorUserInfo.userId,
                                    name: callBackHistory.operatorName,
                                    deptId:  callBackHistory.operatorUserInfo.deptId,
                                }];
                                call({code: 1, log: "查询到返回者为：" + callBackHistory.candidateNames[0]});
                            } else {
                                call({code: -1, msg: "未查询到返回者！"})
                            }
                        },
                        errorCallBack: () => {
                            message.error("未查询到返回者！");
                            window.loading.hide();
                        },
                    });
                },
                /**
                 * 弃用按钮点击事件
                 */
                onClickDiscard: (activiti, buttonConf, call) => {
                    let remarksList = []
                    window.loading.hide();
                    that.syncModal.confirm({
                        title: "弃用原因",
                        width:400,
                        content:
                            <div>
                                {that.state.discardReasonList.map((item, index) => (
                                    <DiscardReason isEdit={true} data={item} callBack={({value,type}) => {
                                        remarksList.push({value,type})
                                    }} />
                                ))}
                            </div>,
                        okText: "确定",
                        cancelText: "取消",
                        onOk: ()=>{
                            const result = remarksList.reduce((acc, curr) => {
                                acc[curr.type] = curr;
                                return acc;
                            }, {});
                            const finalData = Object.values(result);
                            if (finalData.every(item => item.value.trim() === "")) {
                                message.destroy();
                                message.warning("至少填写一项弃用原因！");
                                return;
                            }
                            let data = {
                                remarks: JSON.stringify(finalData),
                                type: "remarks",
                            }
                            activiti.actForm.values.otherData = {remarks:data.remarks}
                            call({ code: 1 });
                            that.syncModal.destroy();
                            window.loading.show();
                        },
                        onCancel: ()=>{
                            that.syncModal.destroy();
                            window.loading.hide();;
                        }
                    });
                }
            },//流程按钮点击事件前置js
            saveFunction: that.saveStory,//稿件保存方法
            saveStatusNameFunction: that.updateStatusName,//稿件改流程状态方法
            onSubmitOK: function (activiti) {
                that.refresh(activiti)
            },//流程事件运行完毕的回调
            successCall: () => {
            },//流程加载完的回调
            readyCall: () => {
            },//流程初始化完的回调
            showRemarks: (remarks) => {
                let remarksData;
                try {
                    remarksData = JSON.parse(remarks)
                    remarksData.forEach(item => {
                        const matchReason = this.state.discardReasonList.find(reason => reason.value === item.type);
                        if (matchReason) {
                            matchReason.text = item.value;
                        }
                    });
                } catch (error) {
                    console.log('error: ', error);
                }
                if (Array.isArray(remarksData)) {
                    this.setState({ showReason: true, remarks :remarksData,})
                }else if(remarks && remarks.length) {
                    this.setState({showRemarks:true,remarks})
                }
            },//备注回显
            onlyShowBtn: true,//是否只返回流程按钮
            title: '',//流程弹窗title
            visible: false,//流程弹窗是否展示
            mustNotShowPublishBtn: true, // 投稿编辑器中永远不显示发布按钮
            btnLoadOver: (btns) => {
                this.activitiBtns = btns;
                this.setState({});
            },
            showBtnIcon: true,
            showLockCall: (data) => {
                // data={status: true, id: this.messageId}  true 加锁成功，只有当前人可编辑，  false 加锁失败，不可编辑，
                // 如果加锁失败，则开启遮罩
                if (!data.status) {
                    this.Editor.showLockMask(data);
                    this.state.isLockedData = data;
                    this.setState({})
                }
            },
            btnType: "editor",
            checkForm: that.checkForm,
        };
        this.setState({});
    }

    // 根据收稿稿件返回相应的投稿稿件
    findOldUuid = ({id,call}) => {
        this.request({
            url: "/cm-sites-pms/story/getContributeStory",
            body: {storyId: id},
            loading:false,
            callBack: (res) => {
                if (res && res.id) {
                    this.state.storyId = res.id;
                    call && call(res)
                } else {
                    call && call(null)
                }
            },
            serverVerify: {
                serverErrorCallBack: () => {
                    call && call(null)
                },
                isShowErrorMsg: false
            }
        })
    };

    // 渲染稿件编辑器
    render() {
        return super.render();
    }

    getActBtnListData() {
        let buttonListData = super.getActBtnListData();
        if(!buttonListData) {
            return buttonListData
        }
        let showPickup= false;
        let showDiscard = false;
        let showAgain = false;
        let canDo = this.canDo;
        let hideBtn = this?.urlParams?.hideBtn;
        if(this.storyData.statusName === '已采用' && canDo && !hideBtn){
            showPickup = true;
            showDiscard = true;
        }
        if(this.storyData.statusName === '已弃用' && canDo && !hideBtn){
            showAgain = true;
        }
        return {
            ...buttonListData,
            //拾取至
            savePickup:this.savePickup,
            showPickup:showPickup,
            //弃用
            saveDiscard:this.saveDiscard,
            showDiscard:showDiscard,
            //重新采用
            saveAgain:this.saveAgain,
            showAgain: showAgain,
            showReason:this.state.showReason
        }
    }

     // 点击查看回调编辑
     showRemarksCall = () =>{
        let that = this;
        that.syncModal.confirm({
            title: "备注",
            width: 400,
            content: <TextArea value={that.state.remarks} placeholder={"请输入"} maxLength={200} rows={2}
                               style={{width: 350, height: 64, fontSize: 14}}
                               ref={(remarksTextArea) => that.remarksTextArea = remarksTextArea}/>,
            okText: "确定",
            cancelText: "取消",
            footer: <Button onClick={()=>{that.syncModal.destroy();}}>关闭</Button>,
            onOk: () => {
                that.syncModal.destroy();
            },
            onCancel: () => {
                that.syncModal.destroy();
            }
        });
    };

    //查看弃用原因
    showDiscardReasonCall = () =>{
        let that = this;
        that.syncModal.confirm({
            title: "弃用原因",
            width:400,
            content:<div>
                {that.state.discardReasonList.map((item, index) => (
                    <DiscardReason isEdit={false} data={item}/>
                ))}
            </div>,
            okText: "确定",
            cancelText: "取消",
            footer: <Button onClick={()=>{that.syncModal.destroy();}}>关闭</Button>,
            onOk: ()=>{
                that.syncModal.destroy();
            },
            onCancel: ()=>{
                that.syncModal.destroy();
            }
        });
    };

    //获取基本信息
    getCurrentInformation() {
        let editorInformation = this.EditorInformation.getInformation();
        return editorInformation
    }

    saveAgain=()=>{
        this.saveStory(true, (data)=>{
            if(data) {
                let currentUser = getInfoFromLocalStorage("currentUser");
                let userId = currentUser.id;
                let deptId = currentUser.defaultInfo.dept.id;
                this.advanceStoryProcess({
                    status: {
                        id: data.id,
                        statusName: "已采用"
                    },
                    process: {
                        activitiCategoryKey: this.getPojoName(data),
                        bizKey: data.id,
                        operatorUserInfo: {userId, deptId,},
                        taskName: "已采用",
                        title: data.title,
                        data: data,
                        otherData: {remarks: ""}
                    },
                    msg_json: data
                },(res)=>{
                    if(res) {
                        message.success('已重新采用成功！',0.5,()=>{
                            this.refresh()
                        });
                    } else {
                        message.warning("采用失败，请稍后重试")
                    }
                });
                // 调用流程down接口增加一条流程记录，并清除备注信息
                // this.activityCone({
                //     data,
                //     uuid: data.id,
                //     title: data.title,
                //     remarks: "",
                //     taskName: "已采用",
                //     call: () => {
                //         this.updateStatusName("已采用", true, (res)=>{
                //             if(res&&res.status) {
                //                 message.success('已重新采用成功！',0.5,()=>{
                //                     this.refresh()
                //                 });
                //             }
                //         })
                //     }
                // });
            }
        })
    };

    savePickup=()=>{
        let that = this;
        that.syncModal.confirm({
            title: "拾取至",
            width: 450,
            key: uuid(),
            content: <RenderPicker
                ref={ref=>that.RenderPicker = ref}
                key={uuid()}
                widthValue={400}
                paddingRight={12}
                id={that.storyData.id}
                data={that.storyData}
                // treeData={this.state.treeData}
                mediaClick={(media) => {
                    that.media = media;
                    // that.savePickup()
                }}
            />,
            cancelText: "取消",
            okText: "确定拾取",
            onOk: () => {
                if(!that.media || !that.media.checked) {
                    message.destroy();
                    message.warning("请先选择一个媒体");
                    return false
                }
                if(!(that.storyData && that.storyData.id)) {
                    message.destroy();
                    message.warning("稿件ID丢失，请刷新页面重试");
                    return false
                }

                that.RenderPicker.onClickPicker({media:that.media,id:that.storyData.id,data:that.storyData});
                that.syncModal.destroy();
                that.media=""
            },
            onCancel: () => {
                that.syncModal.destroy();

                that.media=""
            }
        });
    };

    // 前端弃用采用按钮，添加流程记录=》修改状态=》发消息，三合一接口
    advanceStoryProcess = (body,call) => {
        this.request({
            url: "/cm-sites-dispatch-product/notice/advanceStoryProcess",
            method: "post",
            contentType: "json",
            body,
            callBack: (res) => {
                call&&call(res)
            },
            errorCallBack: (e) => {
                console.log(e.toString())
            }
        })
    };

    saveDiscard=()=>{
        let that = this;
        this.saveStory({options:{statusNameTemp:"弃用"}}, (data)=>{
            if(data) {
                let fun = ({remarks}) => {
                    let currentUser = getInfoFromLocalStorage("currentUser");
                    let userId = currentUser.id;
                    let deptId = currentUser.defaultInfo.dept.id;
                    this.advanceStoryProcess({
                        status: {
                            id: data.id,
                            statusName: "已弃用"
                        },
                        process: {
                            activitiCategoryKey: this.getPojoName(data),
                            bizKey: data.id,
                            operatorUserInfo: {userId, deptId,},
                            taskName: "已弃用",
                            title: data.title,
                            data: data,
                            otherData: {remarks: remarks}
                        },
                        msg_json: data
                    },(res)=>{
                        if(res) {
                            message.success('已弃用成功！',0.5,()=>{
                                this.refresh()
                            });
                        } else {
                            message.warning("弃用失败，请稍后重试")
                        }
                    });
                    // this.activityCone({
                    //     data,
                    //     uuid: data.id,
                    //     title: data.title,
                    //     remarks,
                    //     taskName: "已弃用",
                    //     call: () => {
                    //         this.updateStatusName("已弃用", true, (res)=>{
                    //             if(res&&res.status) {
                    //                 message.success('已弃用成功！',0.5,()=>{
                    //                     this.refresh()
                    //                 });
                    //             }
                    //         })
                    //     }
                    // });
                };
                // 调用流程down接口增加一条流程记录，并增加备注信息
                let remarksList = []
                window.loading.hide();
                that.syncModal.confirm({
                    title: "弃用原因",
                    width:400,
                    content:<div>
                        {that.state.discardReasonList.map((item, index) => (
                            <DiscardReason
                                isEdit={true}
                                data={item}
                                callBack={({ value, type }) => {
                                    remarksList.push({ value, type })
                                }}
                            />
                        ))}
                    </div>,
                    okText: "确定",
                    cancelText: "取消",
                    onOk: () => {
                        const result = remarksList.reduce((acc, curr) => {
                            acc[curr.type] = curr;
                            return acc;
                        }, {});
                        const finalData = Object.values(result);
                        if (finalData.every(item => item.value.trim() === "")) {
                            message.destroy();
                            message.warning("至少填写一项弃用原因！");
                            return;
                        }
                        let data = {
                            remarks: JSON.stringify(finalData),
                            type: "remarks",
                        }
                        fun({remarks: data.remarks,type:data.type});
                        that.syncModal.destroy();
                        window.loading.show();
                    },
                    onCancel: ()=>{
                        that.syncModal.destroy();
                        window.load.end();
                    }
                });
            }
        })
    };

    activityCone = ({taskName, uuid, data, title, remarks, call}) => {
        let currentUser = getInfoFromLocalStorage("currentUser");
        let userId = currentUser.id;
        let deptId = currentUser.defaultInfo.dept.id;
        this.request({
            url: "/cm-sites-sys/process/done",
            method: "post",
            contentType: "json",
            body: {
                activitiCategoryKey: this.getPojoName(data),
                bizKey: uuid,
                title,
                data,
                operatorUserInfo: {userId,deptId,},
                taskName,
                otherData: {remarks}
            },
            callBack: (res) => {
                if(res) {
                    call&&call()
                }
            },
            errorCallBack: (e) => {
            },
        })
    };

    // 渲染稿件栏目模块
    renderEditorPublishInformation = () => {
        return (
            <EditorPublishInformation
                isLine={'noLine'}
                ref={(ref) => {
                    this.editorPublishInformation = ref
                }}
                title={'投稿至'}
                informationConfig={publishInformationConfig}
            />
        )
    };

    checkForm = (activiti, call) => {
        message.destroy();
        // activiti&&activiti.load.start();
        //获取编辑器内容=============start
        let content = this.getEditContent();
        if(!content) {
            window.loading.hide();
            message.warning("请填写内容！");
            return false
        }
        if (content.indexOf("wordimg.png") !== -1) {
            window.loading.hide();
            message.warning("存在从word中复制的不可用的图片，请单独复制图片进行替换");
            return false
        }
        //获取编辑器内容==================end

        // 获取基础属性==================start
        let currentInformation = this.getCurrentInformation();
        if (!currentInformation) {// 基本信息校验（自带）
            window.loading.hide();
            return false
        }
        // let {information, dynamicParams} = currentInformation;
        // 获取基础属性================end
        call&&call()
    };

    /**
     * 稿件保存
     */
    saveStory = (activiti, call) => {
        message.destroy();
        // activiti&&activiti.load.start();
        //获取编辑器内容=============start
        let content = this.getEditContent();
        if(!content) {
            window.loading.hide();
            message.warning("请填写内容！");
            call && call(false);
            return false
        }
        if (content.indexOf("wordimg.png") !== -1) {
            window.loading.hide();
            message.warning("存在从word中复制的不可用的图片，请单独复制图片进行替换");
            call && call(false);
            return false
        }
        //获取编辑器内容==================end

        // 获取基础属性==================start
        let currentInformation = this.getCurrentInformation();
        if (!currentInformation) {// 基本信息校验（自带）
            window.loading.hide();
            call && call(false);
            return false
        }
        if(this.storyData.variableFields){
            currentInformation.variableFields.formatId = this.storyData.variableFields.formatId;
        }
        // let {information, dynamicParams} = currentInformation;
        // 获取基础属性================end

        let id = (this.state.id && this.state.id != '0') ? this.state.id : '';//稿件id
        let that =this;
        window.loading.hide();
        this.LinkCheck.show(content,(res)=>{
            window.loading.show();
            //content 是替换后的内容     status true 就是全部处理，可直接走流程  false  不走流程，把内容 回填编辑器
            if(res) {
                if(res.content) {
                    this.setContent(res.content);
                }
                if(res.status) {
                    content = base64Encode(removeContentSecurity(res.content || content));
                    let params = {
                        ...that.storyData,
                        ...currentInformation,
                        "content": content,
                        "id": id,
                    };

                    if(params && !params.id) {
                        systemBaseEvent.syncExec("editorAddData");
                    }else{
                        systemBaseEvent.syncExec("editorUpdateData");
                    }
                    if(this.publishData?.dbUpdateTime) {
                        // 已经保存过，再次进行保存，需要更新保存时间
                        params.dbUpdateTime = this.publishData.dbUpdateTime
                    }
                    this.request({
                        url: '/cm-sites-pms/story/save',
                        method: 'POST',
                        body: params,
                        contentType: 'json',
                        loading:false,
                        callBack: async (res) => {
                            if (res) {
                                // 备注，这里必须这样写，稿件保存时不会回显同步投递的参数，但是发布时需要
                                this.publishData = {...params,...res,content: base64Encode(removeContentSecurity(res.content))};
                                this.state.id = res.id;
                                // window.loading.hide();
                                systemBaseEvent.syncExec("editorDataChange", res);
                                systemBaseEvent.syncExec("editorIdChange", {editorId: this.state.id});
                                let funs = window.ueditor.afterSaveDataFun;
                                for (let i = 0; funs && i < funs.length; i++) {
                                    let fun = funs[i];
                                    if (fun instanceof Promise) {
                                        await fun(activiti, res, call);
                                    } else {
                                        fun(activiti, res, call);
                                    }
                                }
                                this.securityCheckAsyncCheck({params, activiti, story:res, call});
                                this.updateProcessAndData(this.publishData);
                            } else {
                                message.error('保存失败！');
                                call && call(false);
                            }
                        },
                        errorCallBack: function (e) {
                            call && call(false);
                            message.error('保存失败！');
                        },
                        serverVerify: {
                            serverErrorCallBack: (e,allData) => {
                                window.loading.hide();
                                call && call(false);
                            }
                        }
                    });
                } else {
                    window.loading.hide();
                    call && call(false);
                    return false
                }
            }
        });
    };


}